import { createSelector } from 'reselect';

import { prepareSelector } from 'shared/functions';

export const prepareGlobalSelector = (path: string) => prepareSelector('global', path);

export const selectSettings = prepareSelector('global', 'settings');

export const selectLoadingSkillsTree = prepareGlobalSelector('loadingSkillsTree');

export const selectSkillsTreeLoaded = prepareGlobalSelector('skillsTreeLoaded');
export const selectSkillsTreeLoadedFor = prepareGlobalSelector('skillsTreeLoadedFor');

export const selectLoadSkillsTreeError = prepareGlobalSelector('loadSkillsTreeError');

export const selectSkillsTreeObject = prepareGlobalSelector('skillsTree');

export const selectSkillsTree = createSelector(
  selectLoadingSkillsTree,
  selectLoadSkillsTreeError,
  selectSkillsTreeLoaded,
  selectSkillsTreeLoadedFor,
  selectSkillsTreeObject,
  (loadingSkillsTree, loadSkillsTreeError, skillsTreeLoaded, skillsTreeLoadedFor, skillsTree) => ({
    skillsTree,
    skillsTreeLoaded,
    loadingSkillsTree,
    skillsTreeLoadedFor,
    loadSkillsTreeError,
  }),
);
